import { createApp } from 'vue'
import App from './EnergyTransitionRenewable.vue'

createApp(App).mount('#app-energy-transition-renewable')
